import { render, staticRenderFns } from "./TableRowContentCarriersQuote.vue?vue&type=template&id=a29602b4&scoped=true"
import script from "./TableRowContentCarriersQuote.vue?vue&type=script&lang=js"
export * from "./TableRowContentCarriersQuote.vue?vue&type=script&lang=js"
import style0 from "./TableRowContentCarriersQuote.vue?vue&type=style&index=0&id=a29602b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29602b4",
  null
  
)

export default component.exports